import { alpha, styled } from '@mui/material';
import React from 'react';
import { Stack, Button, IconButton, Tooltip } from '@/theme/index';

export const StyledToolTip = styled(Tooltip)(({ theme }) => ({
  '& .MuiTooltip-arrow': {
    color: alpha(theme.palette.grey[700], 0.9),
  },
  '& .MuiTooltip-tooltip': {
    backgroundColor: alpha(theme.palette.grey[700], 0.9),
    color: theme.palette.common.white,
    fontSize: '0.625rem',
    padding: theme.spacing(0.5, 1),
  },
}));

export const StyledIconButton = styled(IconButton)(({ theme }) => ({
  padding: theme.spacing(1.5),
  color: theme.palette.primary.main,
}));

export const StyledActionsRow = styled(Stack)(({ theme }) => ({
  minWidth: 'max-content',
  backgroundColor: alpha(theme.palette.primary.main, 0.04),
  padding: theme.spacing(0.5, 2),
  borderRadius: '42px',
}));

export const StyledAddReportButton = styled(Button)(() => ({
  flexGrow: 1,
  width: 'max-content',
  fontSize: '1rem',
  letterSpacing: '0.025rem',
}));

export const ActionButtonWithTooltip = ({
  buttonIcon,
  tooltipTitle,
  onClick,
}: {
  buttonIcon: React.ReactElement;
  tooltipTitle: string;
  onClick: () => void;
}) => {
  const handleClick = () => {
    onClick();
  };

  return (
    <StyledToolTip title={tooltipTitle} arrow>
      <StyledIconButton aria-label={tooltipTitle} onClick={handleClick}>
        {buttonIcon}
      </StyledIconButton>
    </StyledToolTip>
  );
};
